import { runFunction } from "../../http";

export const leaveGroup = async (groupId: string): Promise<void> =>
  await runFunction("leaveGroup", { groupId: groupId }, { requireUser: true });
